import { Divider, Grid } from '@material-ui/core'
import React, { FunctionComponent } from 'react'
import Button from 'shared/components/Button'
import { colors } from 'shared/styles/colors'

interface FooterProps {
  onClickBackButton?: () => void
  onClickNextButton?: () => void
  titleBackButton?: string
  titleNextButton?: string
  isNextButtonDisabled?: boolean
}
const Footer: FunctionComponent<FooterProps> = ({
  onClickBackButton,
  onClickNextButton,
  titleBackButton,
  titleNextButton,
  isNextButtonDisabled,
}) => {
  return (
    <Grid container>
      <Divider style={{ width: '100%', margin: '32px 0' }} />
      <Grid container justifyContent="flex-end" alignItems="flex-end">
        {onClickBackButton && (
          <Button
            color={colors.white}
            style={{
              marginRight: 10,
              color: colors.green,
              border: `1px solid ${colors.green}`,
            }}
            onClick={onClickBackButton}
          >
            {titleBackButton}
          </Button>
        )}
        {onClickNextButton && (
          <Button
            color={isNextButtonDisabled ? colors.gray : colors.green}
            onClick={onClickNextButton}
            disabled={isNextButtonDisabled}
            type="submit"
          >
            {titleNextButton}
          </Button>
        )}
      </Grid>
    </Grid>
  )
}

export default Footer
